import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import TagDisplay from './Display';
import { debounce } from 'throttle-debounce';
import { DLAutoComplete } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class TagEditor extends PureComponent {
    constructor(props) {
        super(props);

        this.initialTags = [ ...this.props.currentTags ];
        this.initialTagsText = this.initialTags.map( tag => tag.tagtext );

        this.state = {
            tagOptions: [],
            currentTags: [ ...this.initialTags ],
            searchText: '',
            showResults: false,
            fetching: false,
        };
    }
    componentDidMount() {
        const { childRef } = this.props;
        if( childRef ) {
            childRef( this );
        }
    }
    componentWillUnmount() {
        const { childRef } = this.props;
        if( childRef ) {
            childRef( undefined );
        }
    }
    handleTagUpdate = ( e, data ) => {
        var value = data.value;
        var searchText = value.replace( /\W+/g, '' ).toUpperCase();
        this.setState( {
            searchText: searchText,
        } );
        var shouldSubmit = /[^\s\,\.]+[\s\,\.]$/.test( value );
        if( shouldSubmit ) {
            this.addTag( { tagtext: searchText.toLowerCase() } );
        } else {
            debounce( 50, this.searchForTag( searchText ) );
        }
    }
    searchForTag = ( tag ) => {
        var searchText = tag.replace( /\W+/g, '' ).toUpperCase();
        this.setState( {
            showResults: false,
            fetching: true,
        } );
        if( searchText.length > 0 ) {
            this.props.checkForTag( searchText.toLowerCase(), this.props.channel )
            .then( ( response ) => {
                var currentTagTexts = this.state.currentTags.map( tag => tag.tagtext.toLowerCase() );
                var newOptions = response.filter( option => !currentTagTexts.includes( option.tagtext.toLowerCase() ) );
                newOptions = newOptions.slice( 0, 3 );
                this.setState( {
                    tagOptions: newOptions,
                    showResults: true,
                    fetching: false,
                } );
            } );
        }
    }
    handleTagSelected = ( e, { result } ) => {
        var tag = {
            tagtext: result.title,
            tagid: result.value,
        };
        this.addTag( tag );
    }
    addTag = ( selectedTag ) => {
        if( this.state.currentTags.length > this.props.tagLimit ) {
            // tag adding limit
            alert( 'You cannot add any more tags to this item.' );
            return;
        }
        if( !selectedTag.tagid ) {
            var optionTexts = this.state.tagOptions.map( tag => tag.tagtext );
            var matchLocal = optionTexts.indexOf( selectedTag.tagtext );
            if( matchLocal > -1 ) {
                selectedTag = this.state.tagOptions[ matchLocal ];
            }
        }
        var currentTagTexts = this.state.currentTags.map( tag => tag.tagtext );
        if( currentTagTexts.includes( selectedTag.tagtext ) ) {
            // tag already exists
            alert( 'That tag is already present.' );
            return;
        }
        var tags = this.state.currentTags.concat( [ selectedTag ] );
        this.setState( {
            currentTags: tags,
            searchText: '',
            showResults: false,
            fetching: false,
        } );
        this.props.onUpdate( tags );
    }
    handleTagRemoved = ( index ) => {
        var tags = [ ...this.state.currentTags ];
        tags.splice( index, 1 );
        this.setState( { currentTags: tags } );
        this.props.onUpdate( tags );
    }
    catchKeyPress = ( e ) => {
        if( this.props.catch && ( e.key == 'Enter' ) ) {
            e.preventDefault();
            if( this.state.searchText ) {
                this.addTag( { tagtext: this.state.searchText.toLowerCase() } );
            }
        }
    }
    getTags = () => {
        return this.state.currentTags;
    }
    getTagArrays = () => {
        var activeTags = [ ...this.state.currentTags ];
        var activeTagsTexts = activeTags.map( tag => tag.tagtext );

        var newTags = activeTags.filter( tag => !this.initialTagsText.includes( tag.tagtext.toLowerCase() ) );
        newTags = newTags.reduce( ( accumulator, currentValue ) => {
            accumulator.push( this.props.addTag( currentValue.tagtext ) );
            return accumulator;
        } , [] );

        var deletedTags = this.initialTags.filter( tag => !activeTagsTexts.includes( tag.tagtext.toLowerCase() ) );
        deletedTags = deletedTags.reduce( ( accumulator, currentValue ) => {
            accumulator.push( this.props.deleteTag( currentValue.tagtext ) );
            return accumulator;
        } , [] );
        return [ activeTags, newTags, deletedTags ];
    }
    getTagResults = () => {
        var activeTags = [ ...this.state.currentTags ];
        var activeTagsTexts = activeTags.map( tag => tag.tagtext );

        var newTags = activeTags.filter( tag => !this.initialTagsText.includes( tag.tagtext.toLowerCase() ) );

        var deletedTags = this.initialTags.filter( tag => !activeTagsTexts.includes( tag.tagtext.toLowerCase() ) );

        return { activeTags, newTags, deletedTags };
    }
    render() {
        const { searchText, tagOptions, currentTags, showResults } = this.state;
        const searchResults = tagOptions.map( ( tag ) => {
            return {
                title: tag.tagtext.toUpperCase(),
                value: tag.tagid,
            };
        } );
        return (
            <div className={ style.tagEditor } onKeyPress={ this.catchKeyPress } style={ this.props.style }>
                { this.props.label &&
                    <label>{ this.props.label }</label>
                }
                <TagDisplay
                tags={ currentTags }
                linked={ false }
                deleteHandler={ this.handleTagRemoved }
                multiLine
                white={ this.props.white } />
                <DLAutoComplete
                id='tag-input'
                value={ searchText }
                placeholder={ this.props.placeholder }
                onChange={ this.handleTagUpdate }
                onResultSelect={ this.handleTagSelected }
                results={ searchResults }
                open={ showResults }
                maxLength="40"
                fullWidth
                style={ { marginTop: '7px' } } />
            </div>
        );
    }
}
TagEditor.propTypes = {
    catch: PropTypes.bool,
    currentTags: PropTypes.array,
    tagLimit: PropTypes.number,
    label: PropTypes.string,
    addTag: PropTypes.func,
    deleteTag: PropTypes.func,
    onUpdate: PropTypes.func,
    channel: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.number,
    ] ),
};
TagEditor.defaultProps = {
    catch: true,
    currentTags: [],
    initialTags: [],
    tagLimit: 9,
    label: 'Add Tags (optional)',
    addTag: () => {},
    deleteTag: () => {},
    onUpdate: () => {},
};

const mapDispatchToProps = () => {
    return {
        checkForTag: ( tagText, channelid ) => {
            var query = {
                channel: channelid || undefined,
                limit: 15,
            };
            return dAPI.get( `/tagsearch?search=${ tagText }`, query );
        },
    };
};



export default connect( null, mapDispatchToProps )( TagEditor );
